// Core
import React from 'react'

// Library
import clsx from 'clsx'
import { Input } from 'reactstrap'

// Components
import InputWrapper from 'components/Onboarding/FormFields/InputWrapper'

// Styles
import classes from 'components/Onboarding/FormFields/Input.module.scss'

// Types
interface ITextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  suffix?: string;
  errorMsg?: string | boolean;
  dataCy: string;
}

const TextInput: React.FC<ITextInputProps> = ({
  label,
  suffix,
  name,
  value,
  placeholder,
  onChange,
  onBlur,
  disabled,
  errorMsg,
  className,
  dataCy,
}) => (
  <InputWrapper
    label={label}
    suffix={suffix}
    errorMsg={errorMsg}
    dataCy={`wrapper-${dataCy}`}>
    <div className="position-relative">
      <Input
        id={name}
        name={name}
        type="text"
        className={clsx(
          classes.input,
          className,
        )}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        data-cy={dataCy}
      />
    </div>
  </InputWrapper>
)

export default TextInput
